import React from "react";
import { Link } from "react-router-dom";
import { Butterfly } from "@/components/site/LogoMark";

const NotFound = () => (
  <div className="min-h-[70vh] flex items-center" data-testid="not-found-page">
    <div className="max-w-[900px] mx-auto px-6 md:px-12 lg:px-24 text-center">
      <div className="flex justify-center mb-6"><Butterfly size={40} /></div>
      <h1 className="serif text-6xl md:text-8xl">404</h1>
      <p className="mt-4 text-ink/70">The piece you&rsquo;re looking for is not on this shelf.</p>
      <div className="mt-8"><Link to="/" className="btn-ink">Back to the shop</Link></div>
    </div>
  </div>
);

export default NotFound;
